<template>
  <div
    class="fixed top-5 left-5 w-10 h-10 z-30 flex flex-col"
    @click="openMobileMenu"
  >
    <span class="ham-row"></span>
    <span class="ham-row"></span>
    <span class="ham-row"></span>
  </div>
</template>

<script>
export default {
  methods: {
    openMobileMenu: function() {
      this.$store.commit('MENU_NAV_MOBILE/OPEN_NAV');
    },
  },
};
</script>

<style lang="postcss" scoped>
.ham-row {
  @apply w-10 rounded-lg;
  height: 6px;
  margin-top: 5px;
  background: linear-gradient(157.96deg, #feecbc 0%, #c5a576 100%);
}
</style>
